import React, { useEffect, useState } from "react";
import { Filter, FloatRight, ListView } from "../../components/Mentors";
import { useDispatch } from "react-redux";
import Page from "../../components/Common/Page";
import PagesHeader from "../../components/Common/PagesHeader";
import { getMentorList } from "../../appRedux/actions/mentors";

const MentorList = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    dispatch(getMentorList({ page: 1, size: 50 }));
  }, [dispatch]);

  const handleReset = () => {
    setSearchText("");
    setSelectedStatus("");
    dispatch(getMentorList({ page: 1, size: 50 }));
  };

  return (
    <Page title="Mentors | Expert Guidance">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <PagesHeader
            pageTitle="Industry Mentors & Guides"
            homePageUrl="/"
            homePageText="Dashboard"
            activePageText="Mentors"
            floatRight={<FloatRight />}
          />

          <Filter
            searchText={searchText}
            setSearchText={setSearchText}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            onReset={handleReset}
          />

          <div className="card shadow-sm border-0">
            <div className="card-body p-3">
              <ListView
                searchText={searchText}
                selectedStatus={selectedStatus}
              />
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default MentorList;
